import React, { useEffect } from 'react'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'
import { styled } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTopAssociates } from '../../slices/dashboardSlice'

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '10px',
    border: '2px solid #f1f1f1',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#555',
  },
  scrollbarWidth: 'auto',
  scrollbarColor: '#888 #f1f1f1',
}))

const TopAssociates = () => {
  const dispatch = useDispatch()
  const topAssociates = useSelector((state) => state.dashboard.topAssociates)

  useEffect(() => {
    dispatch(fetchTopAssociates())
  }, [dispatch])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: 1,
        background: '#F6FAFF',
        borderRadius: '20px',
        overflow: 'hidden',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 2,
        display: 'flex',
      }}>
      {/* Top Box */}
      <Box
        sx={{
          width: '100%',
          padding: 0,
          background: '#F6FAFF',
          borderRadius: 2,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}>
        <Typography
          sx={{
            color: '#F6764E',
            fontSize: 20,
            fontWeight: 600,
            wordWrap: 'break-word',
          }}>
          Top 10 New Associates
        </Typography>
      </Box>
      {/* Bottom Box */}
      <Box
        sx={{
          width: '100%',
          padding: 0,
          margin: 0,
          background: '#F6FAFF',
          borderRadius: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '40vh',
        }}>
        <StyledTableContainer
          component={Paper}
          sx={{ boxShadow: 'none', overflowY: 'auto', height: '100%' }}>
          <Table
            stickyHeader
            sx={{ minWidth: 650, backgroundColor: '#F6FAFF' }}
            aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontFamily: 'Work Sans',
                    backgroundColor: '#F6FAFF',
                    color: '#081332',
                    fontSize: 18,
                    fontWeight: 500,
                    borderBottom: 'none',
                    paddingTop: '0px',
                    paddingBottom: '16px',
                    lineHeight: '23.46px',
                  }}>
                  BID-ID
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Work Sans',
                    backgroundColor: '#F6FAFF',
                    color: '#081332',
                    fontSize: 18,
                    fontWeight: 500,
                    borderBottom: 'none',
                    paddingTop: '0px',
                    paddingBottom: '16px',
                    lineHeight: '23.46px',
                  }}>
                  Designation
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Work Sans',
                    backgroundColor: '#F6FAFF',
                    color: '#081332',
                    fontSize: 18,
                    fontWeight: 500,
                    borderBottom: 'none',
                    paddingTop: '0px',
                    paddingBottom: '16px',
                    lineHeight: '23.46px',
                  }}>
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Work Sans',
                    backgroundColor: '#F6FAFF',
                    color: '#081332',
                    fontSize: 18,
                    fontWeight: 500,
                    borderBottom: 'none',
                    paddingTop: '0px',
                    paddingBottom: '16px',
                    lineHeight: '23.46px',
                  }}>
                  Email
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Work Sans',
                    backgroundColor: '#F6FAFF',
                    color: '#081332',
                    fontSize: 18,
                    fontWeight: 500,
                    borderBottom: 'none',
                    paddingTop: '0px',
                    paddingBottom: '16px',
                    lineHeight: '23.46px',
                  }}>
                  Phone
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {topAssociates.map((row) => (
                <TableRow
                  key={row.bidid}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell
                    component='th'
                    scope='row'
                    sx={{
                      borderBottom: 'none',
                      paddingTop: '0px',
                      paddingBottom: '16px',
                    }}>
                    {row.bidid}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: 'none',
                      paddingTop: '0px',
                      paddingBottom: '16px',
                    }}>
                    {row.designation}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: 'none',
                      paddingTop: '0px',
                      paddingBottom: '16px',
                    }}>
                    {row.name}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: 'none',
                      paddingTop: '0px',
                      paddingBottom: '16px',
                    }}>
                    {row.email}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: 'none',
                      paddingTop: '0px',
                      paddingBottom: '16px',
                    }}>
                    {row.phoneNumber1}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </StyledTableContainer>
      </Box>
    </Box>
  )
}

export default TopAssociates
